
import { LeadFormData } from '@/types/leadForm';
import { supabaseLeadService } from './supabaseLeadService';
import { supabase } from '@/integrations/supabase/client';

class HubSpotService {
  async processLead(data: LeadFormData): Promise<boolean> {
    try {
      console.log('Processing lead:', data.email);

      // Primeiro, salva no Supabase (nosso banco de dados)
      console.log('Salvando no Supabase...');
      const supabaseSaved = await supabaseLeadService.saveLead(data);
      if (supabaseSaved) {
        console.log('Lead salvo no Supabase com sucesso');
      } else {
        console.warn('Falha ao salvar no Supabase, mas continuando...');
      }

      // Depois, processa no HubSpot via edge function segura
      console.log('Processando no HubSpot via edge function...');
      
      const { data: result, error } = await supabase.functions.invoke('hubspot-integration', {
        body: { leadData: data }
      });

      if (error) {
        console.error('Erro na edge function do HubSpot:', error);
        // Não falha o processo, apenas loga o erro
      } else {
        console.log('Lead processado no HubSpot com sucesso:', result);
      }

      // Marca como processado no cache
      this.markUserAsProcessed(data.email);

      return true; // Sempre retorna sucesso para não bloquear o fluxo
    } catch (error) {
      console.error('Error processing lead:', error);
      // Marca como processado mesmo em caso de erro para não bloquear o usuário
      this.markUserAsProcessed(data.email);
      return true;
    }
  }

  private markUserAsProcessed(email: string): void {
    const processedUsers = JSON.parse(localStorage.getItem('processedLeads') || '[]');
    if (!processedUsers.includes(email)) {
      processedUsers.push(email);
      localStorage.setItem('processedLeads', JSON.stringify(processedUsers));
    }
  }

  isUserProcessed(email?: string): boolean {
    if (!email) return false;
    const processedUsers = JSON.parse(localStorage.getItem('processedLeads') || '[]');
    return processedUsers.includes(email);
  }

  // Método para verificar se já existe algum lead processado
  hasAnyProcessedLead(): boolean {
    const processedUsers = JSON.parse(localStorage.getItem('processedLeads') || '[]');
    return processedUsers.length > 0;
  }
}

export const hubspotService = new HubSpotService();
